import React, {useState} from 'react';
import Select from 'react-select';
import DatePicker from "./DatePicker";
import SelectStyles from "../SelectStyles";
export default function SearchByOneStationForm({ stations, setStation, setDate, date, search, onClear }) {
	const [displayValue, setDisplayValue] = useState(null);
	const handleChange = (data) => {
		setStation(data.value);
		setDisplayValue(data);
	};
	const clearSelect = () => {
		setStation(null);
		setDisplayValue(null);
		setDate(new Date());
		onClear();
	};
	return (
		<div className={"search-form"}>
			<h2 className={"search-form__title"}>Поиск по одной станции</h2>
			<Select placeholder="станция"
				styles={SelectStyles}
				className={"search-form__select"}
				options={stations}
				onChange={(data) => handleChange(data)}
				value = {displayValue}
			/>
			<DatePicker onChange={setDate} selected={date}/>
			<div className={"search-form__button-container"}>
				<button className={"search-form__button search-form__button_search"} disabled={displayValue===null} onClick={search}>Искать</button>
				<button className={"search-form__button search-form__button_clear"} onClick={clearSelect}>Очистить</button>
			</div>
		</div>
	);
}